{
  "version": 1,
  "asset_id": "55a8a4fc-1fb8-434d-ac02-715605483b04",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/55a8a4fc-1fb8-434d-ac02-715605483b04/sylwia-speaking-white.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/55a8a4fc-1fb8-434d-ac02-715605483b04/sylwia-speaking-white.jpg",
  "original_filename": "sylwia-speaking-white.jpg",
  "size": 514627,
  "content_type": "image/jpeg",
  "created_at": "2026-08-22T08:50:57Z"
}
